/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_MathematicsInputs */

const en_onboarding_genre_mathematics = /** @type {(inputs: Onboarding_Genre_MathematicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mathematics`)
};

const es_onboarding_genre_mathematics = /** @type {(inputs: Onboarding_Genre_MathematicsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matemáticas`)
};

/**
* | output |
* | --- |
* | "Mathematics" |
*
* @param {Onboarding_Genre_MathematicsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_mathematics = /** @type {((inputs?: Onboarding_Genre_MathematicsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_MathematicsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_mathematics(inputs)
	return en_onboarding_genre_mathematics(inputs)
});